import { gql } from 'apollo-angular'

/**
 * The live MG SDNR baseline of a scanner and the tests since its calibration
 * (app server remote schema: server/src/api/baseline.resolver.ts).
 */
export default gql`
  query mgBaselineStatus($scannerId: Int!, $recent: Int) {
    mgBaselineStatus(data: { scannerId: $scannerId, recent: $recent }) {
      scannerId
      routineId
      routineName
      calibrationDate
      since
      provisional
      baselineStudyIds
      baselineTestIds
      values {
        key
        baseline
        low
        high
        problemLow
        problemHigh
      }
      tests {
        id
        scanDate
        dateCreated
        status
        result
        version
        hasSdnr
        stale
        evaluatedAgainst {
          key
          baseline
        }
      }
      testCount
      staleCount
    }
  }
`
